import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import { MastHead } from './MastHead';
import { NavMenu } from './NavMenu';
import { NotificationMessage } from './NotificationMessage';
import { Footer } from './Footer';
import IdleTimerContainer from '../components/IdleTimerContainer';


export class Layout extends Component {

    constructor(props) {
        super(props);       

        this.state = {
            currentNotificationId: null
        };
    }

    componentDidMount() {
        var currentNotId = sessionStorage.getItem("curNotif");
        if (currentNotId) {
            this.setState({ currentNotificationId: currentNotId });
        }
    }

    componentDidUpdate(prevProps) {
        var currentNotId = sessionStorage.getItem("curNotif");
        if (currentNotId !== this.state.currentNotificationId) {
            this.setState({ currentNotificationId: currentNotId });
        }
    }

    render() {
        const { isAuthenticated,currentUser, currentCompanyId, onCompanyChange } = this.props;
        if (isAuthenticated)
            console.log('Rendering Layout ' + currentUser.idleTimeout );
        return (
            (isAuthenticated) ?
                <div className="page-container">
                    <IdleTimerContainer idleTimeout={currentUser.idleTimeout} />
                    <MastHead isAuthenticated={true} currentUser={currentUser}  currentCompanyId={currentCompanyId} onCompanyChange={onCompanyChange} />
                    <NavMenu currentUser={currentUser} currentCompanyId={currentCompanyId} />                    
                    <Container id="mainContent" fluid>
                        <NotificationMessage currentNotificationId={this.state.currentNotificationId} currentCompanyId={currentCompanyId} currentUser={currentUser} />
                        {this.props.children}
                    </Container>
                    <Footer />
                </div>
                : <div className="page-container">
                    <MastHead isAuthenticated={false} />
                    <Container id="mainContent" fluid>
                        {this.props.children}
                    </Container>
                    <Footer />
                </div>
        );

    }
}
